import React from 'react';
import './Examin8Section.css';
import { } from 'react-icons/fa';

const Examin8Section = () => {
    return (
        <section className="examin8-section">
            <div className="examin8-container">
                <div className="examin8-header">
                    <h2 className="examin8-title">ADCI</h2>
                    <h3 className="platform-title">Test & Attendance Platforms</h3>
                    <div className="examin8-underline"></div>
                    <p className="examin8-subtitle">
                        Your Gateway to Success in Competitive Exams
                    </p>
                </div>
                
                <div className="examin8-content">
                    <div className="examin8-features">

                    </div>
                    
                    <div className="examin8-cta">
                        <p className="examin8-description">
                            Experience our state-of-the-art online testing platform designed specifically for competitive exam preparation. 
                            Track your progress, analyze your performance, and get detailed feedback to improve your scores.
                        </p>
                        <p className="examin8-description" style={{ marginTop: '1rem' }}>
                            <strong>New: </strong>
                            You can now also view and track your daily in-out attendance online. Use the Student Attendance Login below to access your attendance records and timings securely.
                        </p>
                        <div className="examin8-buttons" style={{ display: 'flex', gap: '1rem', marginTop: '2rem', justifyContent: 'center' }}>
                            <a 
                                href="https://exams.adcionline.com/" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="examin8-button"
                            >
                                Online Exam Login
                                <span className="button-arrow">→</span>
                            </a>
                            <a
                                href="https://in-out.adcionline.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="examin8-button attendance-button"
                            >
                                Student Attendance Login
                                <span className="button-arrow">→</span>
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.ekodroid.evalbeestudent&pli=1"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="examin8-button offline-result-button"
                            >
                                Offline Result Login
                                <span className="button-arrow">→</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Examin8Section; 